import React, { FC, useState } from 'react';
import { Popup }               from 'semantic-ui-react';
import { Cell, Grid }          from "styled-css-grid";
import _                       from 'underscore';

import { ResourcesService }                     from '../../../../services';
import { CorvalProjectActivity }                from '../../../../types';
import { useProjectTermDictionary }             from '../../../../hooks';
import { CurrencyValue, ModifiedCurrencyValue } from '../../../components/display/CurrencyValue';
import { FinePrintMessage }                     from '../../../components/util/messaging/FinePrintMessage';

interface Props {
	projectActivity: CorvalProjectActivity
}

const defaultProps: Props = {
	projectActivity: null,
}

const ProjectActivityDetailsOperationCost: FC<Props> = ( { projectActivity } ) => {
	
	let { getTerm } = useProjectTermDictionary();
	
	let operationalCost           = ResourcesService.getTotalInitialActivityFees( projectActivity )[ 2 ],
	    calculatedOperationalCost = ResourcesService.getTotalInitialActivityFees( projectActivity, false )[ 2 ];
	
	return !ResourcesService.hasOperationalCostOverride( projectActivity )
	       ? <CurrencyValue value={ operationalCost } emptyOnZero={ true }/>
	       : <Popup
		       wide
		       position={ 'top right' }
		       className={ 'text-left text--sm' }
		       content={
			       <Grid columns={ `auto 1fr` }>
				
				       {/* Header */ }
				       <Cell width={ 2 }>Modified { getTerm( 'BUDGET_COSTS.OPERATIONAL_COSTS.LABEL' ) }</Cell>
				
				       {/* Notes */ }
				       { !_.isEmpty( projectActivity.operationalCostOverrideNote ) &&
				       <Cell width={ 2 }>
					       <FinePrintMessage>{ projectActivity.operationalCostOverrideNote }</FinePrintMessage>
				       </Cell> }
				
				       {/* Original Cost */ }
				       <Cell><strong>Corval calculated cost:</strong></Cell>
				       <Cell><CurrencyValue value={ calculatedOperationalCost } emptyOnZero={ false }/></Cell>
			
			       </Grid> }
		       trigger={ (
			       <abbr className="cursor--pointer" title={ '' }>
				       <ModifiedCurrencyValue value={ operationalCost } emptyOnZero={ true }/>
			       </abbr>
		       ) }/>;
};

ProjectActivityDetailsOperationCost.defaultProps = defaultProps;

export { ProjectActivityDetailsOperationCost }
